export default __webpack_public_path__ + "static/media/img-72.8c7ab0f3.jpg";